<template>
<div class="kt-portlet__head-label">
    <slot></slot>
</div>
</template>

<script>
export default {

}
</script>